<div *ngIf="listData" role="main" class="container" [ngClass]="listData?.containerCss">
    <div class="top-section" (finderIntersection)="setSlimFilters(!$event.isIntersecting)">
        <div class="list-header" #listHeader>
            <hr aria-hidden="true" class="pull-down">
            <finder-title class="list-title" [title]="listData.title" (click)="shrinkMapAndExpandFilters()"></finder-title>
            @defer {
                <finder-multi-select
                    *ngIf="!disableMultiSelect"
                    icon="location-pin"
                    [labels]="listData.labels?.multiSelect"
                    (onSelected)="onMultiSelected($event)">
                </finder-multi-select>
            }
        </div>
        <div class="list-banner" *ngIf="pageBanner?.desktop && isDesktop">
            <finder-anchor [href]="listData.pageBanner?.href" [linkId]="listData.pageBanner?.linkId">
                <finder-picture [picture]="pageBanner"></finder-picture>
            </finder-anchor>
        </div>
        <!--Div with the filters height to avoid a scroll jump in Safari see GIT-41890-->
        <div *ngIf="slimFilters" [style.height.px]="filterHeight"></div>
        <div class="list-filters" #filters *ngIf="!disableFilters; else noFilters" [ngClass]="{'shrink-filters': shrinkFilters, 'slim-filters': slimFilters}">
            <finder-list-filters class="filter" [filters]="listData.filters">
                <finder-button class="remy-dine-cta" remyCta *ngIf="isRemyEnabled"
                    [href]="listData.remyCta.mobile.button.href"
                    [title]="listData.remyCta.mobile.button.title"
                    [theme]="listData.remyCta.mobile.button.theme"
                >{{ listData.remyCta.mobile.button.title }}</finder-button>
            </finder-list-filters>
            <div class="sort" #sort [ngClass]="{'map-only': mapOnly}">
                @defer {
                    <finder-ra-single-select
                        *ngIf="!shrinkFilters && !slimFilters && !mapOnly"
                        [options]="sortOptions"
                        [value]="selectedSortOption"
                        (itemSelected)="onSort($event)">
                    </finder-ra-single-select>
                }
                <ng-container
                    *ngTemplateOutlet="countTemplate; context: {$implicit: listData}"
                ></ng-container>
            </div>
        </div>
    </div>
    <hr aria-hidden="true" #hr class="rule" [ngClass]="{'show-groups': selectedSortOption !== 'name'}"/>
    <ng-container *ngIf="!mapOnly && groups; else noGroups">
        <div #list class="list show-groups {{hideList}}">
            <finder-promo-banner
                *ngIf="listData.promoBanner"
                [promoData]="listData.promoBanner"
            ></finder-promo-banner>
            <div class="group" *ngFor="let group of groups">
                <ng-container *ngIf="group.subgroups; else singleGroup">
                    <div class="header">
                        <div class="header-title">
                            {{group.length}}&nbsp;{{ listData.labels?.sort[group.key] }}
                        </div>
                    </div>
                    <div class="subgroup" *ngFor="let subgroup of group.subgroups">
                        <ng-container
                            *ngTemplateOutlet="groupTemplate; context: {$implicit: subgroup, cardContainer: listCards[group.key]}">
                        </ng-container>
                    </div>
                </ng-container>
                <ng-template #singleGroup>
                    <ng-container
                        *ngTemplateOutlet="singleGroupTemplate; context: {$implicit: group}"
                    ></ng-container>
                </ng-template>
            </div>
            <!-- If there is a filter applied and we get zero results then show the Aristocats message -->
            <finder-no-results
                *ngIf="(!size && loaded && (locationsSelected.length || appliedFacets.length))"
                [labels]='listData.labels.noResults'
                (clearAll)="clearAllFilters()">
            </finder-no-results>
            <finder-loading-spinner *ngIf="!loaded" ></finder-loading-spinner>
        </div>
    </ng-container>
    <ng-template #noGroups>
        <ng-container
            *ngTemplateOutlet="noGroupsTemplate; context: {$implicit: listData}"
        ></ng-container>
    </ng-template>
    @defer {
        <finder-map
            *ngIf="!disableMap"
            #map class="map"
            mapId="list-map"
            (click)="slideControl()"
            (mapIsReady)="mapIsReady($event)"
            [defaults]="mapDefaults"
            (pinsAreDropped)="pinsAreDropped($event)"
            [markerOptions]="markerOptions"
            [markers]="markers">
                <finder-campaign-cta remyCta [ctaData]="listData.remyCta.desktop" *ngIf="isRemyEnabled" class="remy-dine-cta"></finder-campaign-cta>
        </finder-map>
    }
    <!-- Pass in the first set of markers. The rest will filter in -->
</div>

<!-- Top section templates -->
<ng-template #noFilters>
    <div class="list-filters">
        <ng-container
            *ngTemplateOutlet="countTemplate; context: {$implicit: listData}"
        ></ng-container>
    </div>
</ng-template>
<ng-template #countTemplate let-listData>
    <div class="count" aria-live="polite">
        {{size}} <span class="text">{{ listData.labels?.countLabel }}</span>
    </div>
</ng-template>

<!-- Group templates -->
<ng-template #singleGroupTemplate let-group>
    <ng-container
        *ngTemplateOutlet="groupTemplate; context: { $implicit: group, cardContainer: listCards}"
        ngTemplateOutletContext=""
    ></ng-container>
</ng-template>
<ng-template #groupTemplate let-group let-cardContainer="cardContainer">
    <ng-container *ngIf="cardContainer?.[group.key]?.length">
        <div class="card-group" [ngSwitch]="selectedSortOption" *ngIf="group.key !== 'all'">
            <div class="header" *ngSwitchCase="'location'">
                <div *ngIf="group.locationName; else otherLocation" class="header-title">
                    {{ group.locationName }}{{ group.landName ? ', ' : '' }}
                </div>
                <ng-template #otherLocation>
                    {{ listData.labels?.sort.otherLocationsTitle }}
                </ng-template>
                <div *ngIf="group.landName" class="land">
                    {{ group.landName }}
                </div>
            </div>
            <div class="header" *ngSwitchCase="'type'">
                <div *ngIf="group.entityType" class="entity-header-title">
                    {{ group.entityType }}
                </div>
            </div>
            <div class="header" *ngSwitchDefault>
                <div class="header-title">
                    {{ listData.labels?.sort[group.key] }}
                </div>
            </div>
        </div>
        <section class="cards-wrapper" [attr.aria-label]="isDesktop ? listData.labels.card?.ariaLabel : null">
            <finder-list-card
                *ngFor="let card of cardContainer?.[group.key] trackBy: trackByCard; let lastItem=last"
                (finderIntersection)="addCardsToList($event)"
                [intersectionEnabled]="lastItem"
                [rootMargin]="rootMarginListCards"
                [threshold]="thresholdListCards"
                [intersectOnce]="true"
                class="card"
                [card]="card"
                [labels]="listData.labels.card"
                [debug]="debug"
                [options]="listCardsOptions"
                [attr.data-entity-id]="card.id"
                [disablePills]="validatingProcess"
                (validating)="setValidatingProcessState($event)"
                (flyToMarker)="jumpToMarker($event)">
            </finder-list-card>
        </section>
    </ng-container>
</ng-template>

<!-- List templates -->
<ng-template #noGroupsTemplate>
    <div class="list">
        <finder-list-card
            *ngFor="let card of listData.listCards; trackBy: trackByCard;"
            class="card"
            [card]="card"
            [labels]="listData.labels.card"
            [debug]="debug"
            [options]="listCardsOptions"
            [attr.data-entity-id]="card.id"
        ></finder-list-card>
    </div>
</ng-template>
